import { useLang } from '@/i18n';
import EFPicture from '@elem/compCommon/EFPicture';
import { useRouter } from 'next/router';
import { FC, useEffect, useState } from 'react';
import css from './index.module.scss';

const TheComp: FC = () => {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('dp3.landing.Compare');
    const [isClient, setIsClient] = useState(false);

    const tableData = {
        thead: [
            {
                img: '',
                title: '',
            },
            {
                img:
                    locale === 'cn'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1737790224430/DP3_cn.png'
                        : 'https://websiteoss.ecoflow.com/upload/image/1720171665602/sl_DP3%20(2).png',
                title: t('title1'),
            },
            {
                img:
                    locale === 'cn'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1737790224595/DP_cn.png'
                        : 'https://websiteoss.ecoflow.com/upload/image/1720171680298/sl_dp%20(1).png',
                title: t('title2'),
            },
        ],
        tbody:
            locale === 'cn'
                ? [
                      [t('prop1'), t('size1'), t('size2')],
                      [t('prop2'), t('weight1'), t('weight2')],
                      [t('prop3'), t('capacity1'), t('capacity2')],
                      [t('prop4'), t('extend_capacity1'), t('extend_capacity2')],
                      [t('prop5'), t('output1'), t('output2')],
                      [t('prop6'), t('voltage1'), t('voltage2')],
                      [t('prop7'), t('xboost1'), t('xboost2')],
                      [t('prop8'), t('battery_type1'), t('battery_type2')],
                      [t('prop9'), t('cycle1'), t('cycle2')],
                      [t('prop10'), t('EPS_UPS1'), t('EPS_UPS2')],
                      [t('prop11'), t('solar_input1'), t('solar_input2')],
                      ['', '', ''],
                  ]
                : [
                      [t('prop1'), t('size1'), t('size2')],
                      [t('prop2'), t('weight1'), t('weight2')],
                      [t('prop3'), t('capacity1'), t('capacity2')],
                      [t('prop4'), t('extend_capacity1'), t('extend_capacity2')],
                      [t('prop5'), t('output1'), t('output2')],
                      [t('prop6'), t('voltage1'), t('voltage2')],
                      [t('prop7'), t('xboost1'), t('xboost2')],
                      [t('prop8'), t('battery_type1'), t('battery_type2')],
                      [t('prop9'), t('cycle1'), t('cycle2')],
                      [t('prop10'), t('EPS_UPS1'), t('EPS_UPS2')],
                      [t('prop11'), t('solar_input1'), t('solar_input2')],
                      [t('prop12'), t('EV1'), t('EV2')],
                      [t('prop13'), t('AC1'), t('AC2')],
                      [t('prop14'), t('xstream1'), t('xstream2')],
                      [t('prop15'), t('base1'), t('base2')],
                      [t('prop16'), t('port1'), t('port2')],
                      ['', '', ''],
                  ],
    };

    const { thead, tbody } = tableData;

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <div className={`${css.thecomp} GtmModuleData-section`} data-section-id={'dp3-Compare'} data-section-title={t('title')}>
            <div className="dp3-title">{t('title')}</div>
            {isClient && (
                <div className="table-wrapper">
                    <table className="table">
                        <div className="mask"></div>
                        <thead className="thead">
                            <tr className="tr thead-tr">
                                {thead?.map((head: any, k: number) => (
                                    <th className="th td" key="k">
                                        {k === 1 && (
                                            <>
                                                <div className="rect">
                                                    <span className="rect-text">{t('title1')}</span>
                                                </div>
                                                <svg
                                                    className="tringle"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="14"
                                                    height="25"
                                                    viewBox="0 0 14 25"
                                                    fill="none"
                                                >
                                                    <path d="M0.406982 24.588L13.7659 0.355469V24.588H0.406982Z" fill="#2A489A" />
                                                </svg>
                                            </>
                                        )}
                                        {k !== 1 && <p className="bold text title">{head?.title}</p>}
                                        {head?.img && (
                                            <div className="img">
                                                <EFPicture src={head?.img} alt={head?.title} />
                                            </div>
                                        )}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="tbody">
                            {tbody?.map((row: any, m: number) => (
                                <tr className="tr" key={`${m}`}>
                                    {row?.map((col: any, n: number) => (
                                        <td className="td" key={`${m}_${n}td`}>
                                            <p className={`text${n === 0 ? ' bold' : ''}`}>{col}</p>
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default TheComp;
